import React from 'react';
import { Bell as LucideBell } from 'lucide-react';

interface BellProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Bell: React.FC<BellProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideBell width={width} height={height} className={className} style={style} aria-hidden strokeWidth={1.75} />
);

export default Bell;
